import type { FelicitacionStepProps } from "./config";
import IllustratedStepCard from "./IllustratedStepCard";
import step3PreviewImage from "../../../assets/images/felicitacion/mockup_large2_v2.webp";

const Step3 = ({ selectedGrandpa }: FelicitacionStepProps) => {
	return (
		<IllustratedStepCard
			cardPadding="24px 24px 0"
			description="Recuerda poner mucho cariño al hacerlo, estás acompañando a una persona mayor en su día especial."
			imageAlt={`Tarjeta con los datos de ${selectedGrandpa?.name ?? "la persona mayor"}`}
			imageAlign="flex-end"
			imageCompactMarginTop="16px"
			imageCompactMaxHeight="380px"
			imageCompactWidth="300px"
			imageHeight="auto"
			imageJustify="center"
			imageMarginTop="0"
			imageMaxHeight="clamp(420px, 58vh, 560px)"
			imageSrc={step3PreviewImage}
			imageTransform="none"
			title="Redacta tu felicitación"
		/>
	);
};

export default Step3;
